import React from 'react';
import { inputStyles } from '../Input';

export default function InputWrapper(props: Component.DefaultProps) {
  return <div className={inputStyles.wrapper.inputWrapper} children={props.children} />;
}
